module["exports"] = [
  "DŚ",
  "KP",
  "LB",
  "LS",
  "ŁD",
  "MP",
  "MZ",
  "OP",
  "PK",
  "PL",
  "PM",
  "ŚL",
  "ŚK",
  "WM",
  "WP",
  "ZP"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pl/address/state_abbr.js
// module id = 1934
// module chunks = 0